import { useLocalStorage, UseStorageOptions } from "@mantine/hooks"
import { useGetAuthenticatedUser } from "./use-authenticated-user"

type UseUserStorageOptions<T> = Omit<UseStorageOptions<T>, "defaultValue"> & {
  defaultValue: T
}

export function useUserLocalStorage<T>({
  key,
  getInitialValueInEffect,
  defaultValue,
  ...rest
}: UseUserStorageOptions<T>) {
  const {
    data: { userId },
  } = useGetAuthenticatedUser()
  return useLocalStorage<T>({
    key: `${userId}_${key}`,
    getInitialValueInEffect: getInitialValueInEffect ?? false,
    defaultValue: defaultValue,
    ...rest,
  })
}
